/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// REWARDS : POINT INDICATOR : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	pointindicator: {
		whiteSpace: 'nowrap',
		fontSize: pxToEm(14),
		fontWeight: 'bold',
		marginRight: pxToEm(7)
	}
};